module.exports = __webpack_public_path__ + "img/p-failure.3383d8c4.png";